export default __webpack_public_path__ + "static/media/fill.d9f146c7.svg";